import { createSelector } from 'reselect';
import { PlanningByDateState } from '@modules/planning/children/by-date/types';

export const mapWaitingModeSelector = createSelector(
  (state: PlanningByDateState) => state.PlanningByDate.isMapWaitingMode,
  (mapWaitingMode) => mapWaitingMode
);
